import { Row, Col, Form, Input } from "antd";
import MaskedInput from "antd-mask-input";

const Receiver = ({ form, fieldName }) => {
  return (
    <>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            name={[fieldName, "receiverName"]}
            label="Adı:"
            onKeyPress={(e) => {
              if (!/[a-zA-Z wığüşöçĞÜŞÖÇİ]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Lütfen geçerli ad giriniz!",
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={[fieldName, "receiverSurname"]}
            label="Soyadı:"
            onKeyPress={(e) => {
              if (!/[a-zA-Z wığüşöçĞÜŞÖÇİ]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Lütfen geçerli soyad giriniz!",
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={[fieldName, "receiverPhone"]}
            label="Telefon Numarası:"
            rules={[
              {
                required: true,
                message: "Lütfen cep telefonu numarası giriniz!",
              },
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject();
                  }
                  if (
                    value.includes("_") ||
                    /^[1-9][0-9]{9}$/.test(value.replace(/\s+/g, "")) === false
                  ) {
                    return Promise.reject(
                      new Error(
                        "Lütfen cep telefonu numarasını başında 0 olmadan 10 haneli olacak şekilde uygun bir formatta giriniz!"
                      )
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <MaskedInput mask="111 111 11 11" size="10" />
          </Form.Item>
        </Col>
        {/*<Col span={8}>
          <Form.Item
            name="email"
            label="E-Posta Adresi:"
            rules={[
              {
                pattern: new RegExp(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/),
                type: 'email',
                message: 'Lütfen geçerli bir e-posta adresi giriniz!',
              },
            ]}
          >
            <Input />
          </Form.Item>
          </Col>*/}
      </Row>
    </>
  );
};

export default Receiver;
